import { createContext, useCallback, useEffect, useState } from 'react'
import config from '../config'
import Web3Modal from 'web3modal'
import Web3 from 'web3'
import WalletConnectProvider from '@walletconnect/web3-provider'
import { get } from '../adapters/api'
import { rnd } from '../adapters/eth'

export const Web3Context = createContext({})

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      rpc: config.rpc,
    },
  },
}

const web3Modal = new Web3Modal({
  cacheProvider: true,
  theme: 'dark',
  providerOptions, // required
})

const Web3ContextWrapper = ({ children }) => {

  const [web3Provider, setWeb3Provider] = useState(false)
  const [web3, setWeb3] = useState(false)
  const [networkId, setNetworkId] = useState(false)
  const [isConnected, setIsConnected] = useState(false)
  const [defaultAccount, setDefaultAccount] = useState(false)
  const [defaultAccountBalance, setDefaultAccountBalance] = useState('0')
  const [isCorrectNetwork, setIsCorrectNetwork] = useState(false)
  const [rate, setRate] = useState(0)

  useEffect(() => {
    (async () => {
      connectHandler()
    })()
  }, [])

  const connectHandler = async (force = false) => {
    try {
      let provider = false
      let providerNetwork = false
      let account = false
      let balance = '0'

      if (web3Modal.cachedProvider) {
        provider = await web3Modal.connectTo('injected')
      }
      if (!provider && force) {
        provider = await web3Modal.connectTo('injected')
      }

      if (provider) {
        provider.on('chainChanged', () => {
          connectHandler()
        })
        provider.on('accountsChanged', () => {
          connectHandler()
        })

        const web = new Web3(provider)
        setWeb3(web)

        providerNetwork = await web.eth.net.getId()

        const accounts = await web.eth.getAccounts()
        account = accounts[0] ?? false
        balance = accounts[0] ? await web.eth.getBalance(accounts[0]) : '0'
        balance = rnd(balance, 'ether')
      }

      const info = await get('token/config')
      if (info.data) {
        setRate(+info.data.yoc_usd_rate)
      }

      setWeb3Provider(provider)
      setDefaultAccount(account)
      setDefaultAccountBalance(balance)
      setNetworkId(providerNetwork)
      setIsConnected(provider && account)
      setIsCorrectNetwork(provider && account && parseInt(providerNetwork) === parseInt(config.networkId))

    } catch (error) {
      console.log({ web3ModalError: error })
    }
  }

  const connectWeb3 = useCallback(async () => {
    await disconnect()
    await connectHandler(true)
  }, [])

  const disconnect = useCallback(async () => {
    setWeb3Provider(false)
    setWeb3(false)
    setNetworkId(false)
    setIsConnected(false)
    setDefaultAccountBalance('0')
    web3Modal.clearCachedProvider()
  }, [])

  const signMgs = async (data) => {
    try {
      if (typeof data === 'object') {
        data = JSON.stringify(data)
      }
      const params = [Buffer.from(data).toString('hex'), defaultAccount]

      return await window.ethereum.request({ method: 'personal_sign', params })
    } catch (e) {
      return false
    }
  }

  return (
    <Web3Context.Provider
      value={{
        web3,
        isConnected,
        isCorrectNetwork,
        web3Provider,
        networkId,
        defaultAccount,
        defaultAccountBalance,
        connectWeb3,
        disconnect,
        rate,
        signMgs
      }}
    >
      {children}
    </Web3Context.Provider>
  )
}

export default Web3ContextWrapper